import { useEffect, useState } from 'react';

// Below 812px the coordinator hub switches to its stacked mobile layouts.
export const MOBILE_VIEWPORT_QUERY = '(max-width: 811px)';

const readMatches = (query: string): boolean =>
    typeof window !== 'undefined' && Boolean(window.matchMedia) && window.matchMedia(query).matches;

export const useIsMobileViewport = (query: string = MOBILE_VIEWPORT_QUERY): boolean => {
    // Synchronous initial read: no desktop-then-mobile flash on first paint.
    const [isMobile, setIsMobile] = useState<boolean>(() => readMatches(query));

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }
        const mediaQueryList = window.matchMedia(query);
        setIsMobile(mediaQueryList.matches);

        const listener = (event: MediaQueryListEvent) => setIsMobile(event.matches);

        // Safari < 14 only ships the legacy addListener/removeListener API.
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', listener);
        } else {
            mediaQueryList.addListener(listener);
        }

        return () => {
            if (mediaQueryList.removeEventListener) {
                mediaQueryList.removeEventListener('change', listener);
            } else {
                mediaQueryList.removeListener(listener);
            }
        };
    }, [query]);

    return isMobile;
};
